import React from 'react';
import classNames from 'classnames';
import styles from './start-page-section.module.scss';

type StartPageSectionProps = React.ComponentPropsWithRef<'section'> & {
    className?: string;
};

export const StartPageSection = React.forwardRef<
    HTMLElement,
    StartPageSectionProps
>(({ className, ...props }: StartPageSectionProps, ref) => (
    <section
        className={classNames(styles.startPageSection, className)}
        ref={ref}
        {...props}
    />
));

StartPageSection.displayName = 'StartPageSection';
